import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

interface EmailSettingsButtonProps {
  onClick: () => void;
  hasConfig?: boolean;
}

const EmailSettingsButton: React.FC<EmailSettingsButtonProps> = ({ 
  onClick, 
  hasConfig = false 
}) => {
  return (
    <div className="border-top border-translucent pt-3 mt-3">
      <button
        type="button"
        className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center"
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faCog} className="me-2" />
        Configuración Email
        {!hasConfig && (
          <span className="badge bg-warning ms-2" style={{ fontSize: '0.7rem' }}>
            !
          </span>
        )}
      </button>
      {hasConfig && (
        <div className="text-center mt-2">
          <small className="text-success">
            <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
            Configurado
          </small>
        </div>
      )}
    </div>
  );
};

export default EmailSettingsButton;